import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';

import { TReconnectConfig } from '../../types/reconnection-config';
import { AIServiceComponent } from './AIServiceComponent';

export const AIReconnectionConfig: TReconnectConfig = {
  statusesForDisplaying: [
    AppConnectionStatuses.UPDATE_AVAILABLE,
    AppConnectionStatuses.DISCONNECTED,
    AppConnectionStatuses.SUNSET,
    AppConnectionStatuses.UPCOMING_SUNSET,
  ],
  serviceComponent: AIServiceComponent,
};
